"use client"
import { useLayoutEffect, useState } from "react"

const isServer = typeof window === "undefined"
export function useViewPortSize() {
    const [size, setSize] = useState(() => ({
        width: isServer ? 0 : window?.innerWidth,
        height: isServer ? 0 : window?.innerHeight
    }))
    useLayoutEffect(() => {
        function handleResize() {
            setSize({
                width: window.innerWidth,
                height: window.innerHeight
            })
        }
        window.addEventListener("resize", handleResize)
        handleResize()
        return () => window.removeEventListener("resize", handleResize)
    }, [])
    return size
}
